import * as React from "react"
import Seo from "../components/atoms/Seo/Seo"
import LayoutGeneral from "../components/organisms/Layout/LayoutGeneral"
import { css } from "@emotion/react";
import SectionBackground from "../components/molecules/SectionBackground/SectionBackground"
import Paragraph from "../components/atoms/Paragraph/Paragraph"

export default function GraciasLibroReclamaciones() {

  const [urlPDF, setUrlPDF] = React.useState('')

  React.useEffect(() => {
    // Obtener URL del PDF de sessionStorage
    const pdf = sessionStorage.getItem('urlPDF')
    if (pdf) {
      setUrlPDF(pdf)
      sessionStorage.removeItem('urlPDF') // Limpiar después de usarlo
    }
  }, [])

  const colorLineas = "#284b54";
  const titulo = "<p>GRACIAS POR<br>INFORMARNOS</p>";
  const subtitulo = "NOS COMUNICAREMOS CONTIGO PRONTO Y ATENDEREMOS TU RECLAMO O QUEJA EN UN PLAZO NO MAYOR A QUINCE (15) DÍAS HÁBILES.";

  const sectionCss = css`
    padding-top: calc(100vw * (calc(70 / var(--width_base))));
    padding-bottom: calc(100vw * (calc(70 / var(--width_base))));
  `;

  const titleCss = css`
    font-size: calc(100vw * (calc(35 / var(--width_base))));
    line-height: calc(100vw * (calc(35 / var(--width_base))));
    font-weight: 600;
    margin-bottom: calc(100vw * (calc(30 / var(--width_base))));
  `;

  const boxTitleCss = css`
    border-top: calc(100vw * (calc(3 / var(--width_base)))) solid ${colorLineas};
    border-bottom: calc(100vw * (calc(3 / var(--width_base)))) solid ${colorLineas};
    //margin-bottom: calc(100vw * (calc(50 / var(--width_base))));
    padding-top: calc(100vw * (calc(27 / var(--width_base))));
    padding-bottom: calc(100vw * (calc(27 / var(--width_base))));
    max-width: calc(100vw * (calc(430 / var(--width_base))));
  `;

  const subtitleCss = css`
    font-size: calc(100vw * (calc(18 / var(--width_base))));      
    line-height: calc(100vw * (calc(18 / var(--width_base))));
    @media (max-width: 767px) {
        font-size: calc(100vw * (calc(15 / var(--width_base))));
    }
  `;

  const pdfSectionCss = css`
    margin-top: calc(100vw * (calc(20 / var(--width_base))));
    font-family: "Gotham", sans-serif; 
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `;

  const pdfTitleCss = css`
    font-size: calc(100vw * (calc(20 / var(--width_base))));
    font-weight: 600;
    margin-bottom: calc(100vw * (calc(15 / var(--width_base))));
    color: #000;
    font-family: "Gotham", sans-serif; 
  `;

  const pdfMessageCss = css`
    font-size: calc(100vw * (calc(16 / var(--width_base))));
    margin-bottom: calc(100vw * (calc(20 / var(--width_base))));
    text-align: center;
    font-family: "Gotham", sans-serif;
  `;


  const pdfButtonCss = css`
    display: inline-block;
    padding: calc(100vw * (calc(10 / var(--width_base)))) calc(100vw * (calc(20 / var(--width_base))));
    background-color: transparent;
    color: #000;
    text-decoration: underline;
    border: 1px solid #000;
    border-radius: 0;
    font-weight: 600;
    cursor: pointer;
    font-size: calc(100vw * (calc(14 / var(--width_base))));
    transition: color 0.3s;
    font-family: "Gotham", sans-serif; 
  `;

  const contentRightCss = css`
    padding-left: calc(100vw * (calc(45 / var(--width_base))));
    padding-top: calc(100vw * (calc(50 / var(--width_base))));
    padding-bottom: calc(100vw * (calc(50 / var(--width_base))));
    font-family: "Gotham", sans-serif;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media (max-width: 767px) {
          padding-right: calc(100vw * (calc(20 / var(--width_base))));
          padding-left: calc(100vw * (calc(20 / var(--width_base))));
    }
  `;


  const contentCss = css`
    display: flex;
    font-family: "Gotham", sans-serif;
    @media (max-width: 767px) {
        flex-wrap: wrap;
    }
  `;

  return (
    <LayoutGeneral>
      <Seo title="Gracias - Libro de reclamaciones" />
      <h1 className="d-none">Gracias - Libro de reclamaciones</h1>
      <SectionBackground widthContent={950} styleCss={sectionCss} styleCssContent={contentCss}>
        <div className="grid-100" css={contentRightCss}>
          <div css={boxTitleCss}>
            {titulo && <Paragraph text={titulo} styleCss={titleCss} />}
            {subtitulo && <Paragraph text={subtitulo} styleCss={subtitleCss} />}
          </div>

          {urlPDF && (
            <div css={pdfSectionCss}>
              <h2 css={pdfTitleCss}>Tu Constancia de Reclamo</h2>
              <p css={pdfMessageCss}>Te enviaremos la constancia de tu reclamo o queja por correo electrónico. También puedes descargarla aquí:</p>
              <a
                href={urlPDF}
                download
                target="_blank"
                rel="noopener noreferrer"
                css={pdfButtonCss}
              >
                Descargar PDF
              </a>
            </div>
          )}
        </div>


      </SectionBackground>
    </LayoutGeneral>
  )
}
